import { ReactNode } from 'react';

import { LayoutGridElement } from 'components/Layout/Grid';

export const EventBodyElement = ({ children }: { children: ReactNode }) => (
  <LayoutGridElement gridColumn="3/ span 12">{children}</LayoutGridElement>
);
